<template>
  <Card :title="$t('global.redis')" logo="redis">
    <CardListContent :list="getList()" />
  </Card>
</template>

<script>
import Card from "@/components/display/Card";
import CardListContent from "@/components/display/card-sub-components/CardListContent";

export default {
  name: "Redis",
  components: {
    Card,
    CardListContent,
  },
  props: {
    site: Object,
  },
  setup(props, { root }) {
    const getList = () => [
      {
        label: root.$t("global.version"),
        content: props.site.environment.software.redis.version,
        canCopy: true,
      },
      {
        label: root.$t("global.location"),
        content: props.site.environment.software.redis.socket,
        canCopy: true,
      },
    ];

    return {
      getList,
    };
  },
};
</script>
